
import * as $ from 'jquery';

import * as EventEmitter from 'src/shared/eventEmitter/EventEmitter';

/**
 * The process tracker is an event-driven wrapper around tracking the progress of an Ally Process. When
 * created, the tracker will begin tracking progress immediately, emitting a `progress` event on each
 * polling interval. If it fails, an 'error' event is emitted. On success, a 'finished' event is emitted.
 *
 * @param  {String}     processId   The id of the process to track
 * @param  {Number}     interval    How long to wait between polling intervals
 */
export function AbstractTracker(interval) {
    this.interval = interval || 1000;

    // Indicates if the tracker is cancelled
    this._cancelled = false;


    // Begin tracking immediately
    this._poll();
}

AbstractTracker.prototype = Object.create(EventEmitter.prototype);
AbstractTracker.prototype.constructor = AbstractTracker;

/** Needs to be overriden by implementation to provide a URL to poll */
AbstractTracker.prototype.url = function() {
    throw new Error('url() method needs to be implemented');
};

/** Needs to be overriden by implementation to provide custom headers */
AbstractTracker.prototype.headers = function() {
    return {};
};

/**
 * Can be overriden if the returned states use different enum values.
 *
 * The values should correspond to what the REST APIs return
 */
AbstractTracker.prototype.states = function() {
    return {
        'failed': 'Failed',
        'success': 'Succeeded'
    };
};

/** Cancel the process */
AbstractTracker.prototype.cancel = function() {
    this._cancelled = true;
    this.emit('cancelled');
};

/** Recursively poll the process status until it reaches a terminal state (succeeded or failed) */
AbstractTracker.prototype._poll = function() {
    var self = this;
    if (self._cancelled) {
        // Bail out if we've been cancelled
        return;
    }

    var url = self.url();
    var knownStates = self.states();
    var headers = self.headers();
    $.ajax({
        'url': url,
        'type': 'GET',
        'headers': headers,
        'crossDomain': true,
        'success': function(result) {
            if (self._cancelled) {
                // Bail out if we were cancelled while the request was in progress
                return;
            }

            if (result.status === knownStates.success) {
                return self.emit('finished');
            } else if (result.status === knownStates.failed) {
                return self.emit('error', { 'code': 500, 'msg': 'Processing is reported to have failed' });
            } else {
                self.emit('progress', result.status);
                return setTimeout(function() {
                    // Recursively poll if we haven't succeeded or failed
                    self._poll();
                }, self.interval);
            }
        },
        'error': function(xhr, code) {
            if (self._cancelled) {
                // Bail out if we were cancelled while the request was in progress
                return;
            }

            return self.emit('error', {
                'code': code,
                'msg': xhr.responseText
            });
        }
    });
};